import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08d18578"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Clientes Jaú Serve concorrem a prêmios ")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "incríveis", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Fique ligado nas nossas ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "promoções", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Voltar")
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Voltar")
const _hoisted_8 = ["onLoad", "src"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Fechar")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Fechar")
const _hoisted_11 = { class: "b5" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Campanhas e Prêmios ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Saldos Disponíveis ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Limite total ")
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "font-12" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "font-12" }
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_Campanha = _resolveComponent("Campanha")!
  const _component_Raspadinha = _resolveComponent("Raspadinha")!
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_alert, {
        "is-open": _ctx.isOpenRef,
        header: "Ativação",
        "sub-header": "Important message",
        message: "Ativado com sucesso",
        buttons: ['OK'],
        onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(false)))
      }, null, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.isOpenAtivacao,
        "initial-breakpoint": 0.50,
        breakpoints: [0, 0.25, 0.5, 0.75]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper, {
                pagination: true,
                modules: _ctx.modules,
                autoplay: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center b1",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                class: "ion-icon",
                                icon: _ctx.iconPremio
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "b2 layout_blue",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1,
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "b3 layout_blue",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3,
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modules"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.campanha.iframe.show
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.campanha.iframe.show=false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconVoltar }, null, 8, ["icon"]),
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("iframe", {
            name: "frame",
            src: _ctx.campanha.iframe.url,
            frameborder: "0",
            style: {"overflow":"hidden","height":"100%","width":"100%"},
            height: "100%",
            width: "100%",
            webkitallowfullscreen: "",
            mozallowfullscreen: "",
            allowfullscreen: ""
          }, null, 8, _hoisted_6)
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.raspadinha.iframe.show
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.raspadinha.iframe.show=false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconVoltar }, null, 8, ["icon"]),
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("iframe", {
            onLoad: _ctx.ifLoad,
            name: "frame",
            src: _ctx.raspadinha.iframe.url,
            frameborder: "0",
            style: {"overflow":"hidden","height":"100%","width":"100%"},
            height: "100%",
            width: "100%",
            webkitallowfullscreen: "",
            mozallowfullscreen: "",
            allowfullscreen: ""
          }, null, 40, _hoisted_8)
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.campanha.show
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.campanha.show=false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconFechar }, null, 8, ["icon"]),
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Campanha, {
            campanhas: _ctx.campanha,
            campanha: _ctx.campanha.selecionada
          }, null, 8, ["campanhas", "campanha"])
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.raspadinha.show
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.raspadinha.show=false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconFechar }, null, 8, ["icon"]),
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Raspadinha, {
            campanhas: _ctx.raspadinha,
            campanha: _ctx.raspadinha.selecionada
          }, null, 8, ["campanhas", "campanha"])
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[5] || (_cache[5] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat font-25 layout_blue"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_ion_icon, {
                      class: "ion-icon",
                      icon: _ctx.iconPremio
                    }, null, 8, ["icon"])
                  ]),
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.conta_digital.saldo > 0)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 0,
                class: "ion-align-items-center",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "font-poppins-extra font-25"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "saldo",
                    size: "6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.conta_digital.descricao), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$cart.currencyUSD(_ctx.conta_digital.saldo)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "saldo",
                    size: "6"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "saldo",
                    size: "6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$cart.currencyUSD(_ctx.conta_digital.limite)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 1,
                class: "ion-align-items-center bg_white"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_spinner, { name: "dots" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_ion_row, {
                key: 2,
                class: "ion-align-items-center bg_white"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campanhas.sorteio, (sorteio, index) => {
                    return (_openBlock(), _createBlock(_component_ion_col, {
                      class: "ion-text-center ion-padding",
                      key: index,
                      size: "12"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.showRaspadinha(sorteio)),
                          class: "font-montserrat-bold button-nav"
                        }, [
                          _createTextVNode(_toDisplayString(sorteio.label) + " ", 1),
                          _createElementVNode("p", _hoisted_16, _toDisplayString(sorteio.btnparticipar), 1)
                        ], 8, _hoisted_15)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campanhas.promocional, (promocional, index) => {
                    return (_openBlock(), _createBlock(_component_ion_col, {
                      class: "ion-text-center ion-padding",
                      key: index,
                      size: "12"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.showCampanha(promocional)),
                          class: "font-montserrat-bold button-nav"
                        }, [
                          _createTextVNode(_toDisplayString(promocional.nomecategoria) + " ", 1),
                          _createElementVNode("p", _hoisted_18, _toDisplayString(promocional.btnparticipar), 1)
                        ], 8, _hoisted_17)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.premios, (premio, index) => {
                    return (_openBlock(), _createBlock(_component_ion_col, {
                      class: "ion-text-center",
                      key: index,
                      size: "12"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(premio.dataAquisicao) + " " + _toDisplayString(premio.nomePremio) + " ", 1),
                        _createElementVNode("img", {
                          class: "img-text",
                          width: "70",
                          src: premio.urlImagemPremio
                        }, null, 8, _hoisted_19)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}